import States from "../db/states.json";
import Tolls from "../db/tolls.json";
import Parkings from "../db/parkings.json";
import GasStations from "../db/gasstations.json";
import ParkingMeters from "../db/parkingmeters.json";
import Sales from "../db/sales.json";
import CarWashing from "../db/carwashing.json";

export default class Database {
  result = new Map();

  constructor() {
    if (this.constructor.instance) {
      return this.constructor.instance;
    }
    this.constructor.instance = this;

    this.result.set("toll", {
      name: "Peajes",
      length: Tolls.length,
      disable: false,
      data: [],
    });
    this.result.set("parking", {
      name: "Parqueaderos",
      length: Parkings.length,
      disable: false,
      data: [],
    });
    this.result.set("parkingmeters", {
      name: "Parquímetros",
      length: ParkingMeters.length,
      disable: false,
      data: [],
    });
    this.result.set("gasstations", {
      name: "Estaciones de servicio",
      length: GasStations.length,
      disable: false,
      data: [],
    });
    this.result.set("carwashing", {
      name: "Lava autos",
      length: CarWashing.length,
      disable: false,
      data: [],
    });
    this.result.set("sales", {
      name: "Puntos de venta",
      length: Sales.length,
      disable: false,
      data: [],
    });
  }

  getState(stateId) {
    return States.find((state) => state.id === stateId);
  }

  getAllStates() {
    return States;
  }

  searchPoints(state) {
    let element = this.result.get("toll");
    element.data = !element.disable
      ? Tolls.filter((toll) => toll.properties.state === state || state === -1)
      : [];
    this.result.set("toll", element);

    element = this.result.get("parking");
    element.data = !element.disable
      ? Parkings.filter((parking) => parking.properties.state === state || state === -1)
      : [];
    this.result.set("parking", element);

    element = this.result.get("parkingmeters");
    element.data = !element.disable
      ? ParkingMeters.filter((parking) => parking.properties.state === state || state === -1)
      : [];
    this.result.set("parkingmeters", element);

    element = this.result.get("gasstations");
    element.data = !element.disable
      ? GasStations.filter((gas) => gas.properties.state === state || state === -1)
      : [];
    this.result.set("gasstations", element);

    element = this.result.get("sales");
    element.data = !element.disable
      ? Sales.filter((sale) => sale.properties.state === state || state === -1)
      : [];
    this.result.set("sales", element);

    element = this.result.get("carwashing");
    element.data = !element.disable
      ? CarWashing.filter((car) => car.properties.state === state || state === -1)
      : [];
    this.result.set("carwashing", element);

    return this.result;
  }

  getClusters() {
    let clusters = new Array();
    clusters = clusters.concat(Tolls)
    clusters= clusters.concat(GasStations)
    clusters= clusters.concat(Parkings)
    clusters= clusters.concat(ParkingMeters)
    clusters= clusters.concat(Sales)
    clusters= clusters.concat(CarWashing)
    return {
        "type": "FeatureCollection",
        "features": clusters
    }
  }

  getServices() {
    return this.result;
  }

  disableService(service, isDisable) {
    let element = this.result.get(service);
    element.disable = isDisable
    this.result.set(service, element);
  }
}
